/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import HazardEditionSelectMenu from './HazardEditionSelectMenu.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectAvailableEditions } = modelTypesByForm[form];
  return {
    editions: selectAvailableEditions(state),
  };
};

export default connect(mapStateToProps)(HazardEditionSelectMenu);
